import isArray from "lodash/isArray";
import isBoolean from "lodash/isBoolean";
import isElement from "lodash/isElement";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isError from "lodash/isError";
import isFunction from "lodash/isFunction";
import isNumber from "lodash/isNumber";
import isPlainObject from "lodash/isPlainObject";
import isString from "lodash/isString";
import isSymbol from "lodash/isSymbol";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import isRegExp from "lodash/isRegExp";
import { info } from "./native";
const isType = {
    array: isArray,
    boolean: isBoolean,
    element: isElement,
    empty: isEmpty,
    deepEqual: isEqual,
    error: isError,
    function: isFunction,
    number: isNumber,
    plainObject: isPlainObject,
    string: isString,
    symbol: isSymbol,
    undefined: isUndefined,
    null: isNull,
    regexp: isRegExp
};
const isChelun = {
    /**判断车轮系APP */
    chelun: info.chelun,
    /**判断登录 */
    chelunLogin: info.isLogin,
    /**判断车轮APP */
    clApp: info.chaweizhang,
    chaweizhang: info.chaweizhang,
    /**判断车轮社区 */
    sqApp: info.chelunshequ,
    chelunshequ: info.chelunshequ,
    /**判断驾考通APP */
    jkApp: info.jiakaotong,
    jiakaotong: info.jiakaotong,
    /**判断超级教练APP */
    cjApp: info.chaojijiaolian,
    chaojijiaolian: info.chaojijiaolian
};
export const is = Object.assign(Object.assign(Object.assign({}, isType), isChelun), { android() {
        return /Android/i.test(window.navigator.userAgent);
    },
    ios() {
        return /iPhone|iPad/i.test(window.navigator.userAgent);
    },
    weixin() {
        return /MicroMessenger/i.test(window.navigator.userAgent);
    },
    QQ() {
        return /QQ/i.test(window.navigator.userAgent);
    },
    iphoneX() {
        return (/iPhone/gi.test(window.navigator.userAgent) && window.screen.height >= 812);
    },
    touchable() {
        return !this.undefined(window.ontouchstart);
    } });
